import { Controller } from '@hotwired/stimulus'
import '../charts/index.js'
// Connects to data-controller="fund"

export default class extends Controller {
  static targets = ['compareChart']
  static values = {
    fundId: String,
    showBench: Boolean,
    isMobile: Boolean,
    compareData: Array,
    scServer: String
  }

  connect() {
    this.loadChart()
    if (this.isMobileValue && this.showBenchValue) {
      window.addEventListener('svgchart:loaded', ({ detail: { status } }) => {
        if (
          status !== MST.SvgChartTechnical.DATA_STATUS_OK &&
          status !== MST.SvgChartTechnical.DATA_STATUS_LOADING
        ) {
          this.chartCompareBoxTarget.classList.add('hidden')
        } else {
          this.chartCompareBoxTarget.classList.remove('hidden')
        }
      })
    }
    this.handleClick = this.handleClick.bind(this);
    document.addEventListener("click", this.handleClick);
  }
  disconnect() {
    document.removeEventListener("click", this.handleClick);
    if (this.chart) {
      // 刪掉圖表
      if (this.hasCompareChartTarget) {
        this.compareChartTarget.innerHTML = '';
      }
      this.chart = null
    }
  }

  loadChart() {
    MST.SvgChart.setTimeFormatFunction(SW.ChartIntegration.formatTime)
    MST.SvgChart.setNumberFormatFunction(SW.ChartIntegration.formatNumber)
    MST.SvgChart.setTranslateFunction(SW.ChartIntegration.translateString)
    MST.sc_server = this.scServerValue
    this.drawCompareChart()
  }

  drawCompareChart() {
    let chart = this.compareChartTarget
    this.chart = new MST.SvgChart(chart)
    let benchmarks = {
      '.N225': { id: '.N225', name: '日経平均', type: 'index', index: 0 },
      '.TOPX': { id: '.TOPX', name: 'TOPIX', type: 'index', index: 1 },
      '.DJI': { id: '.DJI', name: 'ダウ', type: 'index', index: 2 },
      // New code
      '2TCE01': { id: '2TCE01', name: '金', type: 'futures', index: 3 },
      '2TCE12': { id: '2TCE12', name: '原油', type: 'futures', index: 4 },
      'JPY=X': { id: 'JPY=X', name: '米ドル/円', type: 'futures', index: 5 },
    }
    for (let i = 0; i < this.compareDataValue.length; i++) {
      let type = 'fund'

      if (i == 0) { type = 'default' }

      benchmarks[this.compareDataValue[i][0]] = {
        id: this.compareDataValue[i][0],
        name: this.compareDataValue[i][1],
        type: type,
        index: i + 6,
      }
    }

    this.chart.colorSelectList = {}
    this.chart.setLanguage('jp')
    this.chart.setBenchmarks(benchmarks)

    MST.BENCHMARK_LIMIT = this.isMobileValue ? 5 : 10
    MST.RANGE_VIEW_HEIGHT = this.isMobileValue ? 70 : 32
    this.chart.setParams(
      this.compareDataValue[0][0],
      this.compareDataValue[0][1],
      'TYO',
      {
        controller: {
          timeFrame: '1Y',
          showController: true,
          showIndicator: false,
          showBenchmark: true,
          showUpdateBrowser: true,
          showChartRange: true,
          showType: false,
          showReset: false,
          ranges: ['3M', '6M', '1Y', '3Y', '5Y', '10Y', 'ALL'],
        },
        scroll: { showScroll: true },
        technicalList: [['line']],
      },
    )

    for (var i = 1; i < this.compareDataValue.length; i++) {
      this.chart.addBenchmark(this.compareDataValue[i][0], i)
    }
  }

  handleClick(e) {
    const target = e.target;
    if (e.button !== 0 || target.classList.contains("SvgChartIndicatorControllerView")) {
      return
    }
    // テクニカル 和 ファンドや指数と比較 的 modal
    let indicators = document.querySelectorAll('.SvgChartIndicatorControllerView');
    
    if (!indicators.length) return

    let indicator_button = document.querySelectorAll('.SvgChartControllerIndicator');

    indicators.forEach((indicator, index) => {
      if (window.getComputedStyle(indicator).visibility === 'visible') {
        indicator_button[index]?.click();
      }
    });
  }
}
